import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaUser, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const buttonRef = useRef(null);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        buttonRef.current &&
        !navRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };


    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };


    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-section">
          <img src="/images/logo.jpg" alt="Bolanir Logo" className="logo-img" />
          <h1 className="logo-text">Bolanir</h1>
        </Link>
                <button 
          ref={buttonRef}
          className="hamburger-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

<nav ref={navRef} className={isMenuOpen ? 'active' : ''}>
          <ul className="nav-menu">
            <li>
              <Link to="/" className="nav-link" onClick={closeMenu}>
                <FaHome /> Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="nav-link" onClick={closeMenu}>
                <FaUser /> Chi Siamo
              </Link>
            </li>
            <li>
              <Link to="/contact" className="nav-link" onClick={closeMenu}>
                <FaPhone /> Contatti
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;